<template>
    <v-container max-width="100%" style="margin-top: 2%">

        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <v-select :items="empresas" v-model="empresaSelecionada" item-text="razao_social"
                            item-value="id_empresa" :label="$tc('company.self', 1)" clearable />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-select :items="clientesItens" v-model="clienteSelecionado" item-text="nome_cliente"
                            item-value="id_cliente" :label="$tc('client.self', 1)" clearable />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <MultiplaEscolha lazy get-url="getGruposlazy" :request-data="gruposRequestData" v-bind:selected-items.sync="gruposSelecionados"
                            text="nome" value="id_grupo" :label="$t('relBoarding.header.group')" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12" md="4">
                        <MultiplaEscolha :items="pessoasItens" v-bind:selected-items.sync="pessoasSelecionadas"
                            text="nome_completo" value="id_pessoa" :label="$tc('passenger.self', 1)" :max-items="2" />
                    </v-col>
                    <v-col cols="12" sm="12" md="4">
                        <MultiplaEscolha :items="usuarios" v-bind:selected-items.sync="usuariosSelecionados"
                            text="nome_usuario" value="id_usuario" :label="$t('user.username')" :max-items="2" />
                    </v-col>
                    <v-col cols="12" sm="12" md="4">
                        <MultiplaEscolha :items="canais" v-bind:selected-items.sync="canaisSelecionados"
                            text="cod_canal" value="id_canal" :label="$tc('chanel.self', 2)" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="4" md="5">
                        <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti"
                            :time-picker-props="timeProps" :date-picker-props="dtiProps"
                            :text-field-props="textFieldProps" time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="4" md="5">
                        <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf"
                            :time-picker-props="timeProps" :date-picker-props="dtfProps"
                            :text-field-props="textFieldProps" time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="1" md="1" align="end">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    @click="populaRelatorio" style="margin-bottom: 5px;">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

      <merus-data-table
        :headers="headers"
        :items="enviosFiltered"
        sort-by="dt_envio"
        dense
        class="elevation-7"
        locale="pt"
        :loading="loading"
        :loading-text="$t('system.messages.loading')"
        style="border-radius: 10px; margin-top: 20px;"
      

 cod-tabela="RELCOMUNICACAO" @update:headers="headers = $event">
        <template v-slot:toolbar>
            <CadastroToolbar
                :title="$t('relComunication.title')"
                :token="token"
                :items="enviosFiltered"
                csv-title="enviosmensagens"
                :pdf-title="$t('relComunication.title')"
                :pdf-headers="headers"
                pdf-filename="relenviosmensagens"
                hide-search
            />
        </template>
      </merus-data-table>
    </v-container>

</template>
<script>

import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import apiController from '@/utils/apiController';
import DateUtils from '../utils/dateutils';
import translateDbField from '@/utils/translateDbField';

export default {
    components: {
        MultiplaEscolha,
        MerusDataTable,
        CadastroToolbar
    },
    data: () => ({
    headers: [],
        user: null,
        token: null,
        config: null,
        formValidado: false,
        empresas: [],
        empresaSelecionada: null,
        clientes: [],
        clienteSelecionado: null,
        gruposSelecionados: [],
        pessoas: [],
        pessoasSelecionadas: [],
        canais: [],
        canaisSelecionados: [],
        usuarios: [],
        usuariosSelecionados: [],
        dti: null,
        dtf: null,
        timeProps: {
            useSeconds: true,
        },
        envios: [],
        loading: false,
    }),
    computed: {
        textFieldProps() {
            return {
                prependInnerIcon: "mdi-calendar",
                rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
            }
        },
        headersWithProperties() {
            return this.headers.map(header => ({
                ...header,
                filtrable: true,
                sortable: true
            }));
        },
        clientesItens() {
            return this.empresaSelecionada ? this.clientes.filter((c) => c.id_empresa === this.empresaSelecionada) : this.clientes;
        },
        gruposRequestData() {
            return this.clienteSelecionado ? { id_cliente: this.clienteSelecionado } : {};
        },
        pessoasItens() {
            return this.gruposSelecionados.length > 0 ?
                this.pessoas.filter((p) => this.gruposSelecionados.includes(p.id_grupo) || this.gruposSelecionados.includes(p.id_subgrupo)) :
                this.pessoas;
        },
        today() {
            return new Date().toISOString().substring(0, 10);
        },
        dtiProps() {
            return {
                max: this.today,
            }
        },
        dtfProps() {
            let min = null;
            if (this.dti) {
                if (typeof this.dti === 'string') {
                    min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
                } else {
                    min = this.dti.toISOString().substring(0, 10);
                }
            }
            return {
                min: min,
            }
        },
        enviosFiltered() {
            let dados = this.envios;
            if (this.pessoasSelecionadas.length > 0) {
                dados = dados.filter((d) => this.pessoasSelecionadas.includes(d.id_pessoa));
            }

            if (this.canaisSelecionados.length > 0) {
                dados = dados.filter((d) => this.canaisSelecionados.includes(d.id_canal));
            }

            if (this.usuariosSelecionados.length > 0) {
                dados = dados.filter((d) => this.usuariosSelecionados.includes(d.id_usuario_envio));
            }

            return dados;
        }
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.initialize();
    },
    methods: {

        initialize() {
            this.getConfig();
            this.populaEmpresas();
            this.populaClientes();
            this.populaPessoas();
            this.populaCanais();
            this.populaUsuarios();
        },
        getConfig() {
          apiController.request(apiController.endpoints.getallConfig, {
              onSuccess: (response) => {
                  this.config = response.data[0];
                  [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
              },
              onError: (e) => {
                  this.erro = {
                      type: "Axios",
                      message: e.message,
                      status: e.response.status
                  };
              },
          });
        },
        populaEmpresas() {
            apiController.request(apiController.endpoints.getallEmpresas, {
                onSuccess: (response) => {
                    this.empresas = response.data;
                },
                onError: (e) => {
                    this.erro = {
                        type: "Axios",
                        message: e.message,
                        status: e.response.status
                    };
                },
            });
        },
        populaClientes() {
            apiController.request(apiController.endpoints.getClientesativos, {
                onSuccess: (response) => {
                    this.clientes = response.data;
                },
                onError: (e) => {
                    this.erro = {
                        type: "Axios",
                        message: e.message,
                        status: e.response.status
                    };
                },
            });
        },
        populaPessoas() {
            apiController.request(apiController.endpoints.getallPessoas, {
                data: {},
                onSuccess: (response) => {
                    this.pessoas = response.data;
                },
                onError: (e) => {
                    this.erro = {
                        type: "Axios",
                        message: e.message,
                        status: e.response.status
                    };
                },
            });
        },
        populaCanais() {
            apiController.request(apiController.endpoints.getallCanaiscomunicacao, {
                onSuccess: (response) => {
                    this.canais = response.data;
                },
                onError: (e) => {
                    this.erro = {
                        type: "Axios",
                        message: e.message,
                        status: e.response.status
                    };
                },
            });
        },
        populaUsuarios() {
            apiController.request(apiController.endpoints.getallUsuarios, {
                data: {},
                onSuccess: (response) => {
                    this.usuarios = response.data;
                    const translated = this.usuarios.map(usuario => {
                        return {
                            ...usuario,
                            nome_usuario: translateDbField(usuario.translation_key, usuario.nome_usuario)
                        }
                    });
                    this.usuarios = translated;
                },
                onError: (e) => {
                    this.erro = {
                        type: "Axios",
                        message: e.message,
                        status: e.response.status
                    };
                },
            });
        },
        populaRelatorio() {
            this.loading = true;
            let dti = DateUtils.getDateSQLFormatted(this.dti);
            let dtf = DateUtils.getDateSQLFormatted(this.dtf);

            apiController.request(apiController.endpoints.getEnviosmensagensdata, {
                params: { dti, dtf },
                onSuccess: (response) => {
                    this.envios = response.data;
                    this.loading = false;
                },
                onError: (e) => {
                    this.loading = false;
                    this.erro = {
                        type: "Axios",
                        message: e.message,
                        status: e.response.status
                    };
                },
            });
        }
    }
}
</script>
<style lang="">

</style>